import React from 'react'

const LdsRoller = () => {
  return (
    <div class="lds-roller">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
  )
}

export default LdsRoller
